// extracted by mini-css-extract-plugin
export default {"PlainFeature":"wa_a bhm_b"};